import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export const DeleteConfirmDialog = ({ confirmDelete, setConfirmDelete, onConfirm }) => (
  <AlertDialog open={!!confirmDelete} onOpenChange={(open) => !open && setConfirmDelete(null)}>
    <AlertDialogContent className="border border-zinc-200  rounded-none">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-xl font-heading font-bold uppercase tracking-wide">
          Delete {confirmDelete?.type === 'project' ? 'Project' : confirmDelete?.type === 'phase' ? 'Phase' : 'Order'}?
        </AlertDialogTitle>
        <AlertDialogDescription className="text-zinc-500">
          {confirmDelete?.type === 'project'
            ? `This will permanently delete "${confirmDelete?.name}" and all its phases and orders.`
            : `This will permanently delete "${confirmDelete?.name}". This action cannot be undone.`
          }
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="h-12 px-6 border border-zinc-200 font-bold uppercase" data-testid="cancel-delete-btn">
          Cancel
        </AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          className="h-12 px-6 bg-destructive text-white font-bold uppercase border border-zinc-200 hover:bg-red-600"
          data-testid="confirm-delete-btn"
        >
          Delete
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
